import { render, staticRenderFns } from "./LuPriorityGrid.vue?vue&type=template&id=45df7f31"
import script from "./LuPriorityGrid.vue?vue&type=script&lang=js"
export * from "./LuPriorityGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports